import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { uuid } from '../../../utils/helper';
import ResourceInput from '../ResourceInput';
import ResourceSummaryGrid from '../ResourceSummaryGrid';
import ResourceDetailGrid from '../ResourceDetailGrid';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import FormatAlignLeftIcon from '@material-ui/icons/FormatAlignLeft';
import FormatAlignCenterIcon from '@material-ui/icons/FormatAlignCenter';

const styles = {
  modeButton: {
    display: 'flex',
    paddingTop: 10,
  },
  filler: {
    flex: 1,
  }
}

class ResourceEditor extends React.Component {
  state = {
    mode: 'summary',
  };

  handleChange = (a, b, c) => {
    console.log('handleChange', a, b, c)
  }

  handleAddResource = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign({}, _.omit(spec, ['quantity']), { id: uuid() }));
    console.log('adding resources', resources);
    this.props.onChange((this.props.value || []).concat(resources));
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.onChange(this.props.value.filter((r) => r.id !== resource.id));
  };

  handleResetResource = (state) => _.assign(_.pick(state, ['role', 'start', 'end', 'quantity']), { date: null });

  renderSummary() {
    const { value } = this.props;
    return (<ResourceSummaryGrid value={value}/>);
  }

  renderDetail() {
    const { value, employees } = this.props;
    console.log('employees', employees);
    return (<ResourceDetailGrid
      value={value}
      onChange={this.props.onChange}
      employees={employees}
    />);
  }

  render() {
    const { roles, showError } = this.props;
    const { mode } = this.state;

    return (<div>
      {roles ? <ResourceInput
        roles={roles}
        onAdd={this.handleAddResource}
        onReset={this.handleResetResource}
        showError={showError}
      /> : null}

      <div style={styles.modeButton}>
        <span style={styles.filler}></span>
        <ToggleButtonGroup value={mode} exclusive onChange={(event, mode) => this.setState({ mode })}>
          <ToggleButton value="summary">
            <FormatAlignLeftIcon/> Summary
          </ToggleButton>
          <ToggleButton value="detail">
            <FormatAlignCenterIcon/> Detail
          </ToggleButton>
        </ToggleButtonGroup>
      </div>

      {mode === 'summary' ? this.renderSummary() : this.renderDetail()}
    </div>)
  }
}

ResourceEditor.propTypes = {
  roles: PropTypes.array,
  value: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
  // fetchEmployees: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  showError: PropTypes.func.isRequired,
};

export default ResourceEditor;



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceEditor/index.js